import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pb-x3" }
const _hoisted_2 = { class: "flex flex-col-reverse gap-32 md:flex-row-reverse md:gap-80" }
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = { class: "flex-1" }

import ProductDetailIntro from '@/shared/product/details/ui/ProductDetailIntro.vue';
import ProductDetailVisualization from '@/shared/product/details/ui/visualization/ProductDetailVisualization.vue';
import ProductDetailPrice from '@/shared/product/details/ui/ProductDetailPrice.vue';
import Breakpoints from '@/core/responsive/breakpoints/Breakpoints.vue';
import { computed, onUnmounted } from 'vue';
import OutletProductProperties from '@/shared/product/details/ui/outlet/OutletProductProperties.vue';
import useOutletProductDetailData from '@/shared/product/details/ui/outlet/useOutletProductDetailData';
import OutletRemarks from '@/shared/product/details/ui/outlet/OutletRemarks.vue';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import dictionaryService from '@/core/dictionary/dictionary.service';
import { GlobalLabels } from '@/shared/content/site-context.store';
import ProductDetailCertification from '@/shared/product/details/ui/ProductDetailCertification.vue';
import { useProductImages } from '@/shared/product/details/useProductImages';
import ProductAddOns from '@/shared/product/add-ons/ProductAddOns.vue';
import useProductAddOns from '@/shared/product/add-ons/useProductAddOns';


export default /*#__PURE__*/_defineComponent({
  __name: 'OutletProductDetail',
  setup(__props) {

const { outletProductData: productData, lightingSpecification, productCertificationPrimary, coverMaterial, productAddOnCount, originalSku, environmentalImages } = useOutletProductDetailData();
const { clearAddOns } = useProductAddOns();
const { getProductImages } = useProductImages();
const productImages = computed(() => getProductImages(productData.value.originalSku, productData.value.imageProperties));

onUnmounted(() => clearAddOns);

const globalLabels = useGlobalLabels(GlobalLabels.product);

const outletLabel = computed(() => {
    return dictionaryService.formatNamed(globalLabels.splashLabelOutlet, { percent: productData.value.price.discount?.percentage ?? '' });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breakpoints, null, {
      "max-sm": _withCtx(() => [
        _createVNode(ProductDetailIntro, {
          name: _unref(productData).fullName,
          designer: _unref(productData).designer?.name,
          "splash-label": _unref(outletLabel)
        }, null, 8, ["name", "designer", "splash-label"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Breakpoints, null, {
          "min-md": _withCtx(() => [
            _createVNode(ProductDetailIntro, {
              name: _unref(productData).fullName,
              designer: _unref(productData).designer?.name,
              "splash-label": _unref(outletLabel)
            }, null, 8, ["name", "designer", "splash-label"])
          ]),
          _: 1
        }),
        _createVNode(OutletProductProperties),
        _createVNode(OutletRemarks),
        _createVNode(ProductAddOns, {
          "number-of-items": _unref(productAddOnCount),
          sku: _unref(originalSku)
        }, null, 8, ["number-of-items", "sku"]),
        _createVNode(ProductDetailPrice, {
          price: _unref(productData).price
        }, null, 8, ["price"]),
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ProductDetailVisualization, {
          "product-images": _unref(productImages),
          "cover-material": _unref(coverMaterial),
          "damage-images": _unref(productData).damageImages,
          "environmental-images": _unref(environmentalImages),
          alt: _unref(productData).fullName,
          "product-labels": _unref(productData).productLabels
        }, {
          default: _withCtx(() => [
            _createVNode(ProductDetailCertification, {
              "lighting-specification": _unref(lightingSpecification),
              "product-certification-primary": _unref(productCertificationPrimary)
            }, null, 8, ["lighting-specification", "product-certification-primary"])
          ]),
          _: 1
        }, 8, ["product-images", "cover-material", "damage-images", "environmental-images", "alt", "product-labels"])
      ])
    ])
  ]))
}
}

})